import React from 'react';
import ReferralCriteria from '../Components/ReferralCriteria';

function WithBowelCancer() {
    return ReferralCriteria({
        criteria: [
            (<>Individual diagnosed with bowel cancer under 50 years</>),
            (<>Individual diagnosed with bowel cancer with one first degree relative diagnosed with bowel cancer with an average age under 60 years</>),
            (<>Individual diagnosed with bowel cancer with two first degree relatives diagnosed with bowel, endrometrial, or urothelial malignancy with one diagnosed under 50 years</>),
            (<>Individual with greater than 10 adenomatous bowel polyps under the age of 60.</>),
            (<>Individual with greater than 20 adenomatous bowel polyps iver the age of 60 years</>),
            (<>Individual with colorectal cancer and first degree relative with greater than 10 adenomatous polyps</>),
            (<>Individual with CRC/polyps and a family history of FAP, Lynch syndrome, Peutz-Jeghers syndrome, Juvenile polyposis syndrome, or serrated polyposis.</>)
        ],
        properties: {
            color: 'violet'
        }
    });
}

export default WithBowelCancer;
